import { Link } from 'react-router-dom';
import NewsletterSignup from '../../components/NewsletterSignup/NewsletterSignup';
import './Home.css';

function Home() {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="home__hero" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/Restaurant_interior_with_elegant_lighting.png)` }}>
        <div className="home__hero-overlay"></div>
        <div className="home__hero-content">
          <h1 className="home__title">Cafe Fausse</h1>
          <p className="home__tagline">Fine Dining in the Heart of Washington, DC</p>
          <div className="home__hero-divider"></div>
          <Link to="/reservations" className="btn-primary">Reserve a Table</Link>
        </div>
      </section>

      {/* Info Strip */}
      <section className="home__info section">
        <div className="container">
          <div className="home__info-grid">
            <div className="home__info-item">
              <h3>Visit Us</h3>
              <p>1234 Culinary Ave, Suite 100</p>
              <p>Washington, DC 20002</p>
            </div>
            <div className="home__info-item">
              <h3>Call Us</h3>
              <p><a href="tel:+12025554567">(202) 555-4567</a></p>
            </div>
            <div className="home__info-item">
              <h3>Hours</h3>
              <p>Mon - Sat: 5:00 PM - 11:00 PM</p>
              <p>Sunday: 5:00 PM - 9:00 PM</p>
            </div>
          </div>
        </div>
      </section>

      {/* Highlights Section */}
      <section className="home__highlights section">
        <div className="container">
          <h2 className="section-title">An Unforgettable Experience</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            Blending traditional Italian flavors with modern culinary innovation since 2010.
          </p>
          <div className="home__highlights-grid">
            <div className="home__highlight-card">
              <div className="home__highlight-icon">&#127860;</div>
              <h3>Award-Winning Cuisine</h3>
              <p>Savor dishes crafted by Chef Antonio Rossi, using the finest locally sourced ingredients.</p>
            </div>
            <div className="home__highlight-card">
              <div className="home__highlight-icon">&#127863;</div>
              <h3>Elegant Ambiance</h3>
              <p>Immerse yourself in a warm, sophisticated atmosphere perfect for any special occasion.</p>
            </div>
            <div className="home__highlight-card">
              <div className="home__highlight-icon">&#11088;</div>
              <h3>Exceptional Service</h3>
              <p>Our dedicated team ensures every visit is a memorable, world-class dining experience.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="home__newsletter section">
        <div className="container">
          <h2 className="section-title" style={{ color: 'var(--color-text-light)' }}>
            Join Our Community
          </h2>
          <div className="section-divider"></div>
          <NewsletterSignup variant="hero" />
        </div>
      </section>
    </div>
  );
}

export default Home;
